// https://vuex.vuejs.org/en/actions.html
import Vue from 'vue'
import axios from 'axios'

export default {
  login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')

      axios.post('/api/oauth/token', { 
        grant_type: 'password',
        username: user.username, 
        password: user.password,
      })
        .then(response => {
          const accessToken = response.data.access_token
          const refreshToken = response.data.refresh_token

          const tokenExpiration = new Date()
          tokenExpiration.setSeconds(tokenExpiration.getSeconds() + response.data.expires_in)

          localStorage.setItem('token', accessToken)
          localStorage.setItem('refresh_token', refreshToken)
          localStorage.setItem('token_expiration', tokenExpiration)

          axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken
          
          commit('auth_success', [accessToken, refreshToken, tokenExpiration])

          resolve(response)
        })
        .catch(err => {
          commit('auth_error')

          reject(err)
        })
    })
  },
  refreshAccess ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
  
      axios.post('/api/oauth/token', { 
        grant_type: 'refresh_token',
        refresh_token: localStorage.getItem('refresh_token'), 
      })
        .then(response => {
          const accessToken = response.data.access_token
          const refreshToken = response.data.refresh_token
  
          const tokenExpiration = new Date()
          tokenExpiration.setSeconds(tokenExpiration.getSeconds() + response.data.expires_in)
  
          localStorage.setItem('token', accessToken)
          localStorage.setItem('refresh_token', refreshToken)
          localStorage.setItem('token_expiration', tokenExpiration)
  
          axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken
          
          commit('auth_success', [accessToken, refreshToken, tokenExpiration])
  
          resolve(response)
        })
        .catch(err => {
          commit('auth_error')
  
          reject(err)
        })
    })
  },
  logout ({ commit }) {    
    return new Promise((resolve, reject) => {
      axios.get('/api/logout')
        .then(response => {    
          localStorage.clear()

          delete axios.defaults.headers.common.Authorization                  

          commit('logout')

          resolve()           
        })
        .catch(err => {        
          reject(err)
        })
    })
  },
  manualLogout ({ commit }) {    
    return new Promise((resolve, reject) => {
      localStorage.clear()

      delete axios.defaults.headers.common.Authorization

      commit('logout')

      resolve()        
    })     
  },
  getCurrentUser ({ commit }) {    
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.users().showAuthorized()
        .then(response => {    
          commit('current_user_request', response.data)        

          resolve(response)
        })
        .catch(err => {        
          reject(err)
        })  
    })
  },
  getUserPermissions ({ commit }) {    
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.userPermissions().listAuthorized()
        .then(response => {
          commit('user_permissions_request', response.data)        

          resolve(response)
        })
        .catch(err => {        
          reject(err)
        })  
    })
  },
}
